import {TweenLite, Power2} from "gsap";

class BackgroundImageRotation {
  constructor($imageTargets) {

    this.paused = true;
    this.playInterval;
    this.index = 0
    this.$imageTargets = $imageTargets
    this.initSetup();

  }
  
  initSetup(){

    let currentImageTarget = this.$imageTargets[this.index];
    TweenLite.to(currentImageTarget, 0.5, {opacity:1})

  }

  stop() {
    this.paused = true;
    clearInterval(this.playInterval)
  }

  next(){
    if(this.$imageTargets.length > 1){

      let nextTarget = (this.$imageTargets[this.index+1] != null ? this.$imageTargets[this.index+1] : this.$imageTargets[0]);
      let currentImageTarget = this.$imageTargets[this.index];
      TweenLite.to(nextTarget, 0.5, {opacity:1})
      TweenLite.to(currentImageTarget, 0.5, {opacity:0})

      if((this.index+1) == this.$imageTargets.length){
        this.index = 0
      }else{
        this.index++
      }
    }
  }

  play() {
    this.paused = false;
    this.playInterval = setInterval(() => {
      this.next()
    }, 3000);
  }
}

export default BackgroundImageRotation;